import { BrandTokens } from "../../../@tokens/BrandTokens";
import { GlobalTokens } from "../../../@tokens/GlobalTokens";
import { hexToRGB } from "../../../helpers/Colors/colors";

export const style: any = {
  theme: {
    button: {
      color: BrandTokens.BrandColorPrimaryPure,
      borderRadius: GlobalTokens.BorderRadiusCircular,
    },
    motion: {
      transitionDuration: GlobalTokens.MotionSwitchSlow?.TransitionDuration,
      transitionTimingFunction: GlobalTokens.MotionSwitchSlow?.TransitionTimingFunction
    },

    notification: {
      top: '4px',
      right: '4px',
      width: '16px',
      height: '16px',
      borderRadius: GlobalTokens.BorderRadiusCircular,
      border: `${GlobalTokens.BorderWidthHairline} solid ${BrandTokens.HighlightColorPure}`,
      backgroundColor: BrandTokens.HighlightColorPure,
      fontFamily: BrandTokens.FontFamily,
      fontWeight: BrandTokens.FontWeightMedium,
      fontSize: GlobalTokens.FontSizeXxs,
      color: BrandTokens.NeutralColorLowDark,
      lineHeight: GlobalTokens.LineHeightDefault
    },

    sizes: {
      sm: {
        height: '32px',
        width: '32px'
      },
      lg: {
        height: '48px',
        width: '48px'
      }
    },

    states: {
      hover: {
        backgroundColor: hexToRGB(BrandTokens.BrandColorPrimaryLight, GlobalTokens.OpacityLevelMedium)
      },
      focus: {
        outline: `${GlobalTokens.BorderWidthThin} auto ${BrandTokens.HighlightColorPure}`
      },
      disabled: {
        color: BrandTokens.NeutralColorLowPure,
        opacity: GlobalTokens.OpacityLevelMedium,
        notification: {
          borderColor: BrandTokens.NeutralColorLowPure,
          backgroundColor: BrandTokens.NeutralColorLowPure,
          color: BrandTokens.NeutralColorHighPure
        }
      }
    }
  }
}